<div class="walkthrough-step-container">
  <!-- ICON / BG -->
  <div class="background">
    <ion-img class="background-icon" src="assets/images/walkthrough/search.svg"></ion-img>
  </div>

  <!-- CONTENT -->
  <div class="content">
    <h1 class="content-title header-title">Hey! <br />Are you <b>looking</b> <br />for an Order?</h1>
    <p class="content-subtitle"></p>
    <br />
    <p class="content-description-title">Well you’ve come to the right place…</p>
    <p class="content-description">
      Search for any order by the <b>Customer Name</b> or by the <b>Order ID</b>.<br />
      Find the search icon in the top bar to begin the hunt! <br />Good luck on your quest.
    </p>
  </div>
</div>
